
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Icon from "../icon/icons";

const BTN_PADDING = {
  sm: "p-2", // 8px all sides
  md: "p-3 md:p-5", // 12px mobile / 20px ≥768px
  lg: "p-4 md:p-6", // 16px mobile / 24px ≥768px
};

const BTN_TEXT_SIZE = {  
  xxs: "text-[9px] md:text-[10px]",  
  xs: "text-[10px] md:text-xs", // 10px / 12px
  sm: "text-xs md:text-sm", // 14px
  md: "text-sm md:text-base", // 14px mobile / 16px ≥768px
  lg: "text-lg", // 18px
};

const ICON_SIZE = {
  sm: "w-4 md:w-4", // 16px - matches text-xs/sm
  md: "w-5 md:w-5", // 20px - matches text-sm/base
  lg: "w-6 md:w-6", // 24px - matches text-lg
};

const BTN_VARIANTS = {
  primary: "bg-black text-white",
  secondary: "bg-gray-900 text-white",
  outline: "bg-white border border-grey-50 text-gray-700 hover:bg-gray-50",
  "primary-orange": "bg-orange-500 text-black",
  "primary-blue": "bg-blue-500 text-white",
};

const BTN_RADIUS = {
  pill: "rounded-full",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  sm: "rounded-sm",
  none: "rounded-none",
};



export  function AppButton({
 
  children,
  onClick,
  type = "button",
  size = "md",
  paddingSize,
  textSize,
  variant = "primary",
  radius = "md",
  fullWidth = true,
  loading = false,
  disabled = false,
  className = "",
  leftIcon = null,
  rightIcon = null,
  iconSize = "w-3.5 md:w-5",
  ...rest
}) {
  const isDisabled = disabled || loading;
  const width = fullWidth ? "w-full" : "";
  const resolvedPaddingKey = paddingSize || size || "md";
  const resolvedTextKey = textSize || size || "md";
  const paddingClasses = BTN_PADDING[resolvedPaddingKey] || BTN_PADDING.md;
  const textClasses = BTN_TEXT_SIZE[resolvedTextKey] || BTN_TEXT_SIZE.md;
  

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      aria-busy={loading}
      className={`
        ${BTN_VARIANTS[variant] || BTN_VARIANTS.primary}
        ${BTN_RADIUS[radius] || BTN_RADIUS.pill}
        ${paddingClasses}
        ${textClasses}
        ${width}
        cursor-pointer font-semibold inline-flex items-center justify-center gap-2
        focus:outline-none 
        transition-colors disabled:opacity-60 disabled:cursor-not-allowed
        ${className}
      `}
      {...rest}
    >
      {loading ? (
        <FontAwesomeIcon icon={faSpinner} size="lg" spin />
      ) : (
        <>
          {leftIcon && <Icon name={leftIcon} iconClass={iconSize} />}
          {children}
          {rightIcon && <Icon name={rightIcon} iconClass={iconSize} />}
        </>
      )}
    </button>
  );
}
